// extracted by mini-css-extract-plugin
export default {"classText":"toogleActivemodule_classText__WNPS1"};